import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import { useNotifications } from "./NotificationContext";

export default function NotificationToaster() {
    const { current, closeCurrent } = useNotifications();

    // Auto-close after 4s (if you prefer toast behavior)
    useEffect(() => {
        if (!current) return;
        const t = setTimeout(() => closeCurrent(), 4000);
        return () => clearTimeout(t);
    }, [current]);

    if (!current) return null;

    const statusColor = {
        success: "#16a34a",
        fail: "#dc2626",
        error: "#dc2626",
        info: "#2563eb",
    }[current.status] || "#2563eb";

    return createPortal(
        <div style={styles.overlay} onClick={closeCurrent}>
            <div style={{ ...styles.card, borderLeft: `6px solid ${statusColor}` }} onClick={(e) => e.stopPropagation()}>
                <div style={styles.row}>
                    <strong style={{ color: statusColor, marginRight: 8 }}>
                        {current.status?.toUpperCase() || "INFO"}
                    </strong>
                    <span style={{ color: "#666" }}>{current.refId}</span>
                </div>
                <div style={{ marginTop: 6 }}>{current.message || "(no message)"}</div>

                {current.data && (
                    <pre style={styles.pre}>{JSON.stringify(current.data, null, 2)}</pre>
                )}

                <div style={styles.footer}>
                    <button onClick={closeCurrent} style={styles.button}>Close</button>
                </div>
            </div>
        </div>,
        document.body
    );
}

const styles = {
    overlay: {
        position: "fixed", inset: 0, background: "rgba(0,0,0,0.25)",
        display: "flex", alignItems: "center", justifyContent: "center", zIndex: 9999,
    },
    card: {
        width: "min(520px, 92vw)", background: "#fff", borderRadius: 12, padding: 16,
        boxShadow: "0 12px 30px rgba(0,0,0,0.15)",
    },
    row: { display: "flex", alignItems: "center" },
    pre: { background: "#f6f8fa", padding: 8, borderRadius: 8, marginTop: 8, overflowX: "auto" },
    footer: { marginTop: 12, display: "flex", justifyContent: "flex-end" },
    button: { padding: "6px 12px", borderRadius: 8, border: "1px solid #ddd", background: "#f5f5f5", cursor: "pointer" },
};


//If you prefer a toast (bottom-right, non-blocking), replace overlay with a fixed bottom-right container and don’t dim the background.